import React, { useEffect } from 'react';
import { css } from 'styled-components';

// Components
import Layout from 'src/components/common/theme/Layout';

//helpers
import { checkValue, defaultHeroImage, getDefaultValue, removeImageURLCropParams } from 'src/components/common/helper';
import { getDeviceImage, useProgressiveImg, tinyImage } from 'src/components/common/theme/component';
import { mediaQueries } from 'src/components/common/theme/component-styles';
import { useWindowDimensions } from 'src/components/common/useWindowDimentions';

//types
import { HeroImageProps } from '../../typings';
import { utc } from 'moment';

const HeroImage: React.FC<HeroImageProps> = (props) => {
  const {
    heroImage,
    backgroundPhotoMobile,
    heroImageDescription,
    backgroundColor,
    turnOffCropsForHeroImage,
    template,
  } = props;
  
  const { width: windowWidth } = useWindowDimensions();

  let staticHeroImage = [];
  if (checkValue(heroImage)) {
    staticHeroImage = heroImage;
  } else if (!checkValue(backgroundColor)) {
    staticHeroImage = defaultHeroImage();
  }

  const bgImage = getDeviceImage(staticHeroImage, 'hero-desktop');
  const bgTinyImage = checkValue(getDeviceImage(staticHeroImage, 'hero-tiny-desktop'))
    ? getDeviceImage(staticHeroImage, 'hero-tiny-desktop')
    : tinyImage(bgImage, 'desktop');
  const bgtabImage = getDeviceImage(staticHeroImage, 'hero-tablet');
  const bgtabTinyImage = checkValue(getDeviceImage(staticHeroImage, 'hero-tiny-tablet'))
    ? getDeviceImage(staticHeroImage, 'hero-tiny-tablet')
    : tinyImage(bgtabImage, 'tablet');
    const bgmobileImage = getDeviceImage(checkValue(backgroundPhotoMobile) ? backgroundPhotoMobile : staticHeroImage, 'hero-mobile');
    const bgmobileTinyImage = checkValue(getDeviceImage(checkValue(backgroundPhotoMobile) ? backgroundPhotoMobile : staticHeroImage, 'hero-tiny-mobile'))
      ? getDeviceImage(checkValue(backgroundPhotoMobile) ? backgroundPhotoMobile : staticHeroImage, 'hero-tiny-mobile')
      : tinyImage(bgImage, 'mobile');

  // crop params remove from Image URL
  const newBgTinyImage = removeImageURLCropParams(bgTinyImage);

  // const bgmobileImage = turnOffCropsForHeroImage
  //   ? bgImage
  //   : getDeviceImage(checkValue(backgroundPhotoMobile) ? backgroundPhotoMobile : staticHeroImage, 'hero-mobile');

  // const bgmobileTinyImage = turnOffCropsForHeroImage
  //   ? newBgTinyImage
  //   : checkValue(getDeviceImage(staticHeroImage, 'hero-tiny-mobile'))
  //   ? getDeviceImage(staticHeroImage, 'hero-tiny-mobile')
  //   : tinyImage(bgmobileImage, 'mobile');

  const imageVparam = `v=${utc().format('YYYYMMDDHH')}`;

  const [bgImageSrc] = useProgressiveImg(newBgTinyImage, turnOffCropsForHeroImage ? bgImage.split("?")?.[0]+`?${imageVparam}` : bgImage);
  const [bgTabImageSrc] = useProgressiveImg(bgtabTinyImage, turnOffCropsForHeroImage ? bgtabImage.split("?")?.[0]+`?${imageVparam}` : bgtabImage);
  const [bgMobileImageSrc] = useProgressiveImg(bgmobileTinyImage, turnOffCropsForHeroImage ? bgmobileImage.split("?")?.[0]+`?${imageVparam}` : bgmobileImage);

  const moduleCss = () => {
    return `
        &.hero-image-component {
          ${checkValue(turnOffCropsForHeroImage) && turnOffCropsForHeroImage ? `background-position: center;` : ''}
          ${checkValue(backgroundColor) ? `background-color:${backgroundColor} !important;` : ''}
          ${checkValue(bgImageSrc) ? `background-image: url(${bgImageSrc})!important; ` : ''}
            ${
              checkValue(bgTabImageSrc)
                ? `
                  @media only screen and (max-width: ${mediaQueries.tab}) {
                    background-image: url(${bgTabImageSrc})!important;
                  }
              `
                : ''
            }
            ${
              checkValue(bgMobileImageSrc)
                ? `
                @media only screen and (max-width: ${mediaQueries.tabsmall}) {
                    background-image: url(${bgMobileImageSrc})!important;
                }
            `
                : ''
            }
        }
    `;
  };

  //turnOffCropsForHeroImage funcationality
  useEffect(() => {
    if (turnOffCropsForHeroImage && windowWidth <= 575) {
      const img = new Image();
      img.src = bgmobileImage;
      let imgW = 0;
      let imgH = 0;

      img.onload = () => {
        imgH = img.height;
        imgW = img.width;

        const bgImageH = (windowWidth * imgH) / imgW;
        const elm = document.querySelector(
          '.with-isTurnOffCropsForHeroImage .global-hero-module-container'
        ) as HTMLElement;
        if (elm) {
          elm.style.minHeight = `${bgImageH + 30}px`;
        }
      };
    } else {
      const elm = document.querySelector(
        '.with-isTurnOffCropsForHeroImage .global-hero-module-container'
      ) as HTMLElement;
      if (elm) {
        elm.style.minHeight = `auto`;
      }
    }
  }, [windowWidth, turnOffCropsForHeroImage]);

  return (
    <Layout
      css={css`
        ${moduleCss()}
      `}
      className={`hero-image-component ${template}`}
    >
      <span role="figure" aria-label={getDefaultValue(heroImageDescription, 'Hero Background Image')} />
    </Layout>
  );
};

export default HeroImage;
